import React, { useState, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import Button from '../ui/button';
import { ProfileContext } from '../../contexts/ProfileContext';

import { InfoIcon } from '../icons';
import { getTranslation } from '../../utils';

export default function VideoQuestionaire({
  mainSection,
  secondSection,
  enableDisplayRecorder,
  enableUploadVideo,
  videoURL,
  setVideoDuration,
  setVideoURL,
  setVideoFile,
  isRegional = false,
  videoID,
  regionVideoId = 1,
  orgPrefix,
  allowedToRecord,
  videoPageDetails
}) {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const fileInputRef = useRef(null);
  const recordVideoRef = useRef(null);
  const [isSetVideoUrl, setVideoUrl] = useState(false);
  const [profile] = useContext(ProfileContext);

  const { masterData: { customConfigurations: { colors } = {} } = {} } = profile;

  const continuteButtonHandler = () => {
    enableDisplayRecorder();
  };

  const uploadAndContinue = () => {
    fileInputRef.current.click();
    // enableUploadVideo();
  };

  const recordVideoHandler = () => {
    recordVideoRef.current.click();
  };

  return (
    <>
      {!isRegional && (
        <>
          <div className="border-[1px] border-black rounded-xl p-6 mt-8">
            <p
              className="text-lg text-black font-semibold mb-4 w-full"
              dangerouslySetInnerHTML={{
                __html: videoPageDetails?.tipsTitle?.[i18n.language]
              }}
            />
            <div
              className="video-tips text-black text-base w-full"
              dangerouslySetInnerHTML={{
                __html: videoPageDetails?.tipsDescription?.[i18n.language]
              }}
            />

            <Button.ButtonRounded
              className={'flex gap-2 items-center mt-6'}
              onClick={() => navigate(`/video-tips/${videoID}`)}>
              <InfoIcon />
              <p
                className="text-lg text-white font-semibold"
                dangerouslySetInnerHTML={{
                  __html: videoPageDetails?.tipButtonText?.[i18n.language]
                }}
              />
            </Button.ButtonRounded>
          </div>

          <div className="flex items-center justify-center w-full mt-10">
            <Button.ButtonOutlined
              handler={() => {
                if (!allowedToRecord) {
                  toast.error(
                    videoPageDetails?.strengthOrRoleSelection?.selectionType === 'strength'
                      ? getTranslation(t, `videoTips.strengthMissingError`, orgPrefix)
                      : videoPageDetails?.strengthOrRoleSelection?.selectionType === 'role'
                      ? getTranslation(t, `videoTips.roleMissingError`, orgPrefix)
                      : getTranslation(t, `videoTips.missingError`, orgPrefix)
                  );
                  return;
                }
                uploadAndContinue();
              }}>
              <p
                className="text-lg font-semibold"
                style={{
                  color: colors.primary
                }}
                dangerouslySetInnerHTML={{
                  __html: getTranslation(t, `videoTips.uploadBtn`, orgPrefix)
                }}
              />
            </Button.ButtonOutlined>
          </div>
          <div className="flex items-center justify-center w-full mt-10">
            <Button.ButtonRounded
              onClick={() => {
                if (!allowedToRecord) {
                  toast.error(
                    videoPageDetails?.strengthOrRoleSelection?.selectionType === 'strength'
                      ? getTranslation(t, `videoTips.strengthMissingError`, orgPrefix)
                      : videoPageDetails?.strengthOrRoleSelection?.selectionType === 'role'
                      ? getTranslation(t, `videoTips.roleMissingError`, orgPrefix)
                      : getTranslation(t, `videoTips.missingError`, orgPrefix)
                  );
                  return;
                }
                recordVideoHandler();
              }}>
              <p
                className="text-lg text-white font-semibold"
                dangerouslySetInnerHTML={{
                  __html: getTranslation(t, `videoTips.recordBtn`, orgPrefix)
                }}
              />
            </Button.ButtonRounded>
          </div>
        </>
      )}

      {isRegional && (
        <div className="mt-10">
          <button
            onClick={() => navigate(-1)}
            className="w-fit p-3 text-white rounded-xl bg-cblue-500 absolute left-3">
            <FaAngleLeft />
          </button>
          <h1 className="heading text-cblue-500 text-center text-2xl font-bold w-full">
            {mainSection.heading}: Vidéo {regionVideoId}
          </h1>
        </div>
      )}
      {isRegional && (
        <div className={`mb-4 mt-10`}>
          <div className="mb-6">
            <strong className="">{secondSection.heading}</strong>
            <p className="p" dangerouslySetInnerHTML={{ __html: secondSection.description }}></p>
          </div>
          <div>{!secondSection.noteFirst && <p className="p">{secondSection.note}</p>}</div>
        </div>
      )}
      {isRegional && (
        <div className="text-center mt-20 flex flex-row gap-4 justify-center border-t border-black pt-4 fixed left-0 right-0 bottom-0 pb-3 bg-white">
          <button
            className="w-fit px-4 py-2 text-white rounded-xl bg-cblue-500"
            onClick={continuteButtonHandler}>
            <div className="flex items-center">
              <span>Enregistrer</span>
            </div>
          </button>
          <button
            className="w-fit px-5 py-2 rounded-xl border-2 border-black"
            onClick={uploadAndContinue}>
            <div className="flex items-center">
              <span>Télécharger</span>
            </div>
          </button>
        </div>
      )}
      <input
        ref={fileInputRef}
        id="FileInput"
        className="hidden"
        type="file"
        accept="video/*"
        onChange={function (e) {
          var file = e.target.files[0];
          setVideoFile(file);
          setVideoURL(URL.createObjectURL(file));
          setVideoUrl(true);
        }}
      />
      <input
        ref={recordVideoRef}
        id="RecordVideo"
        className="hidden"
        type="file"
        accept="video/*"
        capture="user"
        onChange={function (e) {
          var file = e.target.files[0];
          setVideoFile(file);
          setVideoURL(URL.createObjectURL(file));
          setVideoUrl(true);
        }}
      />
      {videoURL && isSetVideoUrl && (
        <video
          src={videoURL}
          onLoadedMetadata={function (e) {
            enableUploadVideo();
            setVideoDuration(e.target.duration);
          }}
        />
      )}
    </>
  );
}
